import * as type from './type';
import util from 'common/js/util';

export default{
    //获取购物车内商品总数量
    [type.GET_CART_TOTAL_NUM](context,option){
        let params = {
            functionId: "getTotalNum"
        };
        if (option && option.params && option.params.poolId && option.params.b2bVenderId) {
            params.body = JSON.stringify({
                poolId: option.params.poolId,
                b2bVenderId: option.params.b2bVenderId
            });
        }
        util.post({
            params,
            sc(resp){
                util.jumpToRN("addCart"); //更新tabbar购物车上的数字
                context.commit(type.SET_CART_TOTAL_NUM, resp.data);
                if(option && option.sc){
                    option.sc && option.sc(resp);
                }
            },
            fc(resp){
                if(option && option.fc){
                    option.fc && option.fc(resp);
                }
            }

        });
    },
    [type.ADD_CART](context,option) {
        let params = {
            skuId: option.params.skuId,
            num: option.params.num,
            type: option.params.type //1-主商品 2-赠品 3-附件 4-套装
        };
        let cartNumParam = null;
        if (option && option.params && option.params.poolId && option.params.b2bVenderId) {
            params = {
                ...params,
                poolId: option.params.poolId,
                b2bVenderId: option.params.b2bVenderId
            };
            cartNumParam = {
                params: {
                    poolId: option.params.poolId,
                    b2bVenderId: option.params.b2bVenderId
                }
            };
        }
        util.post({
            params:{
                functionId: "addOneToCar",
                body: JSON.stringify(params)
            },
            sc (resp){
                context.dispatch(type.GET_CART_TOTAL_NUM, cartNumParam);
                if(option && option.sc){
                    option.sc && option.sc(resp);
                }
            },
            fc(resp){
                if(option && option.fc){
                    option.fc && option.fc(resp);
                }
            }
        });
    },
    [type.CHANGE_SKU_NUM](context,option) {
        let params;
        if (option && option.params && option.params.body) {
            let p = JSON.parse(option.params.body);
            if (p.poolId && p.b2bVenderId) {
                params = {
                    poolId: p.poolId,
                    b2bVenderId: p.b2bVenderId
                };
            }
        }
        util.post({
            params:{
                functionId: "changeSkuNum",
                body: option.params.body
            },
            sc (resp){
                context.dispatch(type.GET_CART_TOTAL_NUM, { params });
                if(option && option.sc){
                    option.sc && option.sc(resp);
                }
            },
            fc(resp){
                if(option && option.fc){
                    option.fc && option.fc(resp);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/store/cart/actions.js